import type { CapturedNetworkTiming } from '../lib/session-network-timing.ts'

/** Every `JourneyNetworkWarning.kind`; the session-detail schema parses stored runs against it, so kinds are only ever added. */
export const JOURNEY_NETWORK_WARNING_KINDS = [
  'network-unexpected', 'network-request-mismatch', 'network-missing', 'network-param-substituted', 'network-request-body-unreadable',
  'network-body-truncated', 'network-entity-mismatch', 'network-configured', 'network-unsupported', 'network-retained', 'network-mirror',
  'network-live-unreachable',
] as const
export type JourneyNetworkWarningKind = typeof JOURNEY_NETWORK_WARNING_KINDS[number]

export interface SessionNetworkExchange {
  source_timestamp: number
  timing?: CapturedNetworkTiming
  method: string
  url: string
  status: number
  request_headers: Record<string, string>
  request_body: string | null
  request_body_sha256: string | null
  response_headers: Record<string, string>
  redacted?: { request_body?: true; response_body?: true; metadata?: true }
  response_body: string | null
  /** The detail rendering is incomplete (truncated text or ambiguous empty-container types).
   * It cannot faithfully answer a request; use project rules or a synthetic response instead. */
  response_body_truncated?: true
  /** Subtext omitted an empty-container type; rendered nulls are not authoritative. */
  response_body_ambiguous?: true
  /** Parsed from a display transcript rather than captured response bytes. */
  response_body_rendered?: true
}
